export default "__VITE_ASSET__Di5YCthE__"